export default __webpack_public_path__ + "static/media/apple-logo.721f67ed.png";